// src/components/ProductCarousel.jsx
import { Container, Carousel, Card } from 'react-bootstrap';
import './ProductCarousel.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import p1 from '../assets/p1.png';
import p2 from '../assets/p2.png';
import p3 from '../assets/p3.png';
import p4 from '../assets/p4.png';

const products = [
  {
    id: 1,
    name: 'Pomadas',
    image: p1,
    description: 'Com vários efeitos. Teia, black, matte, neutra e muito mais.',
  },
  {
    id: 2,
    name: 'Balms',
    image: p2,
    description: 'Produto perfeito para manter a sua barba perfumada e macia.',
  },
  {
    id: 3,
    name: 'Máquinas de Corte',
    image: p3,
    description: 'Para você que é profissional ou que deseja adquirir para ter em casa.',
  },
  {
    id: 4,
    name: 'Óleos para a barba',
    image: p4,
    description: 'Óleos para dar brilho e cheiro, de diversos tipos e perfumes.',
  },
];

const ProductCarousel = () => (
  <section className="product-carousel-section py-5">
    <Container>
      <h2 id='shop' className="text-center display-5 mb-4 text-white">Nossos produtos:</h2>
      <Carousel
        variant="dark"
        nextIcon={<span aria-hidden="true" className="carousel-control-next-icon custom-control-icon" />}
        prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon custom-control-icon" />}
      >
        {products.map((prod) => (
          <Carousel.Item key={prod.id}>
            <div className="d-flex justify-content-center">
              <Card bg="dark" text="white" style={{ width: '18rem' }}>
                <Card.Img variant="top" src={prod.image} alt={prod.name} />
                <Card.Body>
                  <Card.Title>{prod.name}</Card.Title>
                  <Card.Text>{prod.description}</Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </Container>
  </section>
);

export default ProductCarousel;
